export default __webpack_public_path__ + "static/media/Footpad's Tunic of the Smoldering Throne.ecf875e5.jpg";